import { ControlledDateOnlyPicker, ControlledTextField, FieldGrid, useFormDialog } from '@if/mui'
import { getToday } from '@src/services/DateTimeProvider'
import { FileCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { chequeDetailsSchema, type ChequeDetailsSchemaType } from './cheque-details-schema'

export interface ChequeDetailsProps {
  paymentCount: number
}

/**
 * Asks for the cheque number and date before a selection is disbursed by cheque. It only
 * collects: the selection form owns the save and its success message, so the dialog stays silent.
 */
export const useChequeDetailsDialog = () => {
  const { t } = useTranslation()

  return useFormDialog<ChequeDetailsSchemaType, ChequeDetailsProps>({
    icon: FileCheck,
    title: t('disburse.cheque.title'),
    subtitle: (ctx) => t('disburse.cheque.subtitle', { count: ctx.props.paymentCount }),
    confirmLabel: t('disburse.actions.applyCheque'),
    confirmIcon: FileCheck,
    maxWidth: 'xs',
    fullWidth: true,
    schema: chequeDetailsSchema,
    defaultValues: () => ({ chequeDate: getToday() }),
    successMessage: false,
    onSubmit: (data) => data,
    content: ({ form }) => (
      <FieldGrid columns={1}>
        <ControlledTextField
          control={form.control}
          name="chequeNumber"
          label={t('disburse.cheque.chequeNumber')}
          autoFocus
        />
        <ControlledDateOnlyPicker
          control={form.control}
          name="chequeDate"
          label={t('disburse.cheque.chequeDate')}
          fullWidth
        />
      </FieldGrid>
    ),
  })
}
